import React from 'react';
import PropTypes from 'prop-types';
// Models
import mWorkspaceGroup from 'models/cpm/workspaceGroup';
// HOCs
import wrapListFilters from 'hocs/WrapListFilters';
// Custom
import {
  listFeatureSearchFieldShape,
  listFilterShape,
} from 'constants/PropTypesShapes';
// Components
import FiltersCardTemplate from 'components/templates/FiltersCardTemplate';
import BaseListFilter from 'components/filters/BaseListFilter';
import TextFieldFilter from 'components/filters/TextFieldFilter';

const WorkspaceGroupFilters = ({
  disabled,
  advanced,
  nbFiltersApplied,
  searchFields,
  field,
  filters,
  isFieldDisplayable,
  onFieldChange,
  onFilterFieldChange,
  onReinit,
  onSwitch,
}) => {
  const { name } = filters;

  return (
    <div className="px-3 mb-3">
      <FiltersCardTemplate
        disabled={disabled}
        advanced={advanced}
        nbFiltersApplied={nbFiltersApplied}
        onReinit={onReinit}
        onSwitch={onSwitch}
      >
        <React.Fragment>
          {!advanced && (
            <div className="col-12 col-md-4 col-xl-3">
              <BaseListFilter
                field={field}
                searchFields={searchFields}
                onChange={onFieldChange}
              />
            </div>
          )}
          {isFieldDisplayable('name') && (
            <div className="col-12 col-md-4 col-xl-3">
              <TextFieldFilter
                label="field.name"
                value={name.value}
                onChange={(value) => onFilterFieldChange('name', value)}
              />
            </div>
          )}
        </React.Fragment>
      </FiltersCardTemplate>
    </div>
  );
};

WorkspaceGroupFilters.propTypes = {
  // From HOC
  disabled: PropTypes.bool.isRequired,
  advanced: PropTypes.bool.isRequired,
  nbFiltersApplied: PropTypes.number.isRequired,
  searchFields: PropTypes.arrayOf(listFeatureSearchFieldShape).isRequired,
  field: PropTypes.string.isRequired,
  filters: PropTypes.shape({
    name: listFilterShape,
  }).isRequired,
  isFieldDisplayable: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFilterFieldChange: PropTypes.func.isRequired,
  onReinit: PropTypes.func.isRequired,
  onSwitch: PropTypes.func.isRequired,
};

module.exports = wrapListFilters(mWorkspaceGroup.listFeatures.searchFields)(
  WorkspaceGroupFilters,
);



// WEBPACK FOOTER //
// ./routes/cpm/routes/workspaces/assets/workspaceGroup/WorkspaceGroupFilters.js